const ComponentBase = require('../../base/ComponentBase');
const LayerUtil = require('../../utils/LayerUtil');
const AppEvents = require('../../misc/AppEvents');
const g2 = require('../../g2');

/**
 * @description 图层信息
 * @typedef G.common.LayerManager~LayerInfo
 * @type {Object}
 * @property {String} id 图层ID
 * @property {String} name 图层名称
 * @property {Boolean} isBase 是否底图
 * @property {Boolean} visible 是否可见
 */

/**
 * @constructor
 * @classdesc 图层管理组件
 * @augments G.base.ComponentBase
 * @alias G.common.LayerManager
 * @param {Object} options
 * @param {G.Map} options.map 地图对象
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        //
    },
    /**
     * @inheritdoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
    },

    /**
     * @inheritdoc
     */
    addListeners() {
        this.map.listen(AppEvents.LAYER_CHANGED, this._onLayerChanged, this);
    },

    /**
     * @inheritdoc
     */
    removeListeners() {
        this.map.off(AppEvents.LAYER_CHANGED, this._onLayerChanged, this);
    },

    //图层变化
    _onLayerChanged(event) {
        let list = this._getList(this._listOptions);
        this.fire('layer_changed', {
            list: list
        });
    },

    /**
     * 获取图层列表
     * @method
     * @memberOf G.common.LayerManager.prototype
     * @param opts {Object}
     * @param opts.filter {Function} 过滤图层
     * @returns {G.common.LayerManager~LayerInfo[]}
     */
    getLayerList(opts) {
        this._listOptions = opts;
        return new Promise((resolve, reject) => {
            this._checkLoaded();
            let list = [];
            list = this._getList(opts);
            resolve(list);
        });
    },

    //
    _getList(opts) {
        opts = opts || {};
        opts.filter = opts.filter || function(layer) {
            return layer.name && layer.id;
        }
        let list = [];
        let defaultGroupLayers = LayerUtil.defaultGroupLayers;
        let defaultGroupLayerSet = {};
        for (let i = 0; i < defaultGroupLayers.length; i++) {
            defaultGroupLayerSet[defaultGroupLayers[i].id] = defaultGroupLayers[i];
        }
        //
        let layers = this.map.getLayers();
        for (let i = 0; i < layers.length; i++) {
            let layer = layers[i];
            if (!opts.filter(layer)) {
                continue;
            }
            if (defaultGroupLayerSet.hasOwnProperty(layer.id)) {
                let groupLayers = layer.groupLayers;
                for (let j = 0; j < groupLayers.length; j++) {
                    let groupedLayer = groupLayers[j];
                    if (!opts.filter(groupedLayer)) {
                        continue;
                    }
                    let layerInfo = this._buildLayerInfo(groupedLayer);
                    list.push(layerInfo);
                }
            } else {
                let layerInfo = this._buildLayerInfo(layer);
                list.push(layerInfo);
            }
        }
        return list;
    },
    //
    _buildLayerInfo(layer) {
        let layerInfo = {};
        layerInfo.id = layer.id;
        layerInfo.name = layer.name;
        layerInfo.isBase = LayerUtil.isBaseLayer(layer);
        layerInfo.visible = layer.visible;
        return layerInfo;
    },

    /**
     * 设置图层显示隐藏
     * @method
     * @memberOf G.common.LayerManager.prototype
     * @param {Object} opts  {Object}
     * @param {String} opts.id 图层ID
     * @param {Object} opts.visible 是否可见
     * @returns {g2.carto.ILayer}
     */
    setLayerVisible(opts) {
        this._checkLoaded();
        let layer = LayerUtil.getLayerById(this.map, opts.id);
        if (layer) {
            layer.setVisible(!!opts.visible);
            return layer;
        }
        return null;
    },

    /**
     * 获取图层信息
     * @method
     * @memberOf G.common.LayerManager.prototype
     * @param id {String} 图层ID
     * @returns {G.common.LayerManager~LayerInfo}
     */
    getLayerInfo(id) {
        this._checkLoaded();
        let layer = LayerUtil.getLayerById(this.map, id);
        if (layer) {
            return this._buildLayerInfo(layer);
        }
        return null;
    },

    /**
     * @inheritdoc
     */
    unload() {
        ComponentBase.prototype.load.call(this);
    },
    /**
     * @inheritdoc
     */
    destroy() {
        ComponentBase.prototype.destroy.call(this);
    }
});
module.exports = component;